// Import Packages
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import Button from '@material-ui/core/Button';

// Import Components
import BaseModal from './BaseModal/BaseModal';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { useSetRecoilState, useRecoilState } from 'recoil';
import { saveAvailable, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';
import { handleUpdate } from '../../../../helpers/flowHistory';

// Import CSS
import './dataTransform.css'

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function DataTransform({ action, variables, setOpenVariable, variableRender, automDetail, actions, setAutomDetail }) {
    const { t } = useTranslation();
    const [showBaseModal, setShowBaseModal] = useState(false);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.DATA-TRANSFORM.';

    useEffect(() => {
        if (!action.fields.data) {
            action.fields.data = { value: {}, type: 'ARRAY', isRequired: true }
        }
    }, [action.item_id])

    // When the configure button in the configuration form is pressed, the registered data is assigned
    const openAssignModal = () => {
        if (!action.fields.data) {
            action.fields.data = { value: {}, type: 'ARRAY' }
        }
        setShowBaseModal(true);
    }

    const cancel = () => {
        setShowBaseModal(false);
    }

    const afterSave = () => {
        let copyItems = JSON.parse(JSON.stringify(automDetail.items))

        findAndUpdateItem(copyItems)
        handleUpdate(copyItems);
        setAutomDetail({
            ...automDetail,
            items: copyItems
        })

        // The save button was activated with every confirmation
        CheckIfFlowUpdated("data", action, "", "-", setSaveAvailable, setChangeFields, changedFieldsState);
        setShowBaseModal(false);
    }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                return;
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'HEADER')} is_required />
                <Button className='configure-button-css' onClick={openAssignModal}>
                    {t(label + 'CONFIGURE')}
                </Button>
            </div>
            {showBaseModal &&
                <BaseModal baseAction={action} item_id={action.item_id} cancel={cancel} variables={variables} setOpenVariable={setOpenVariable}
                    variableRender={variableRender} automDetail={automDetail} actions={actions} afterSave={afterSave} />
            }
        </div>
    );
}

export default DataTransform;
